import { useEnhancedQuery } from "@uplift-ltd/apollo";
import React from "react";
import { PageIdType } from "__generated__/globalTypes";
import {
  STATIC_PAGE_QUERY,
  StaticPageQuery,
  StaticPageQueryVariables,
} from "components/StaticPageTemplate";
import SubscriptionProducts from "components/Subscriptions/SubscriptionProducts";
import ErrorPage from "components/common/ErrorPage";
import Layout from "components/common/Layout";
import { FullPageLoading } from "components/common/Loading";
import { SUBSCRIPTION_NAME_PLURAL } from "constants/site";
import { SUBSCRIPTIONS_SLUG } from "constants/urls";
import { getServerSideSEO, SeoPageProps } from "helpers/seo";
import { withEnhancedServerSideProps } from "helpers/withEnhancedProps";
import { usePageMeta } from "hooks/usePageMeta";

const SubscriptionsPage = ({ seo, title }: SeoPageProps) => {
  const { data, loading } = useEnhancedQuery<StaticPageQuery, StaticPageQueryVariables>(
    STATIC_PAGE_QUERY,
    {
      variables: { id: SUBSCRIPTIONS_SLUG, idType: PageIdType.URI },
    }
  );

  const page = data?.page;
  const pageHeader = data?.page?.heroSection;

  usePageMeta(title, seo);

  if (loading) return <FullPageLoading />;
  if (!page || !pageHeader) return <ErrorPage />;

  return (
    <Layout initialMeta={seo}>
      <SubscriptionProducts
        title={pageHeader.title}
        summary={pageHeader.summary}
        content={page?.content}
      />
    </Layout>
  );
};

export default SubscriptionsPage;

const PAGE_TITLE = SUBSCRIPTION_NAME_PLURAL;

export const getServerSideProps = withEnhancedServerSideProps<SeoPageProps>(async ctx => {
  if (ctx.isInitialRequest) {
    const seoProps = await getServerSideSEO(ctx, SUBSCRIPTIONS_SLUG, PAGE_TITLE);

    return {
      props: seoProps,
    };
  }

  return {
    props: { title: PAGE_TITLE },
  };
});
